import React from 'react';
import {View} from 'react-native';
import {Avatar, Card, CheckBox, ListItem, makeStyles} from '@rneui/themed';
import {observer} from 'mobx-react';

import {useStores} from '../../../stores/use-stores';
import Text from '../../themed/Text';
import AddressModal from '../AddressModal';

import PersonAcceptingTheOrder from './PersonAcceptingTheOrder';

function OrderDetails() {
  const styles = useStyles();
  const {cartStore, userStore} = useStores();
  return (
    <View style={styles.containerStyle}>
      <Text color="black" variant="heading3">
        Order details
      </Text>
      {!!cartStore?.isDelivery && (
        <>
          <PersonAcceptingTheOrder />
          <Card.Divider />
        </>
      )}
      <AddressModal addressType="billing">
        {({handleOpen}) => (
          <>
            <ListItem onPress={handleOpen}>
              <Avatar
                icon={{
                  name: 'credit-card-marker-outline',
                  type: 'material-community',
                  size: 24,
                  color: 'black',
                }}
              />
              <ListItem.Content>
                <ListItem.Subtitle>
                  <Text variant="caption">
                    Billing address
                  </Text>
                </ListItem.Subtitle>
                  <ListItem.Title>
                    <Text variant="body2">
                      {userStore.billingAddress
                        ? `${userStore.billingAddress?.lines?.[0]} ${userStore.billingAddress?.locality}`
                        : `Set address for billing`}
                    </Text>
                  </ListItem.Title>
              </ListItem.Content> 
              <ListItem.Chevron size={24} color={styles.text.color} />
            </ListItem>
            <Card.Divider />
          </>
        )}
      </AddressModal>
      <ListItem>
        <Avatar
          icon={{
            name: 'snowflake-o',
            type: 'font-awesome',
            size: 24,
            color: 'black',
          }}
        />
        <ListItem.Content>
          <ListItem.Title>
            <Text variant="body2">Chill my drinks</Text>
          </ListItem.Title>
        </ListItem.Content>
        <CheckBox
          checked={cartStore.chillDrinks}
          onPress={() => {
            cartStore.setChillDrinks(!cartStore.chillDrinks);
          }}
          iconRight
          iconType="material-community"
          checkedIcon={'checkbox-marked'}
          uncheckedIcon={'checkbox-blank-outline'}
          containerStyle={{padding: 0, margin: 0, marginRight: 0}}
        />
      </ListItem>
      <Card.Divider />
    </View>
  );
}

const useStyles = makeStyles(theme => {
  return {
    containerStyle: {
      marginTop: 30,
    },
    text: {
      color: theme.colors?.legacy?.text?.heading?.primary,
    },
  };
});

export default observer(OrderDetails);
